var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding":"15px"}},[_vm._v("\n\n    对不起，您请求的页面不存在、或已被删除、或暂时不可用\n\n")])}
var staticRenderFns = []

export { render, staticRenderFns }